<template>
  <div>
    <svg viewBox="0 0 64 64">
      <path
        class="background"
        d="M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0s32 14.3 32 32-14.3 32-32 32"
      />
      <path
        class="text"
        d="M54.8 42.1c.4.4.5.5.5.8V44c0 .2-.2.4-.4.4h-5.6c-.8-.6-1.2-1.5-1.1-2.5V26.2c-.1-.6-.7-1-1.2-1-.7 0-1.6.5-1.6 1v15.2c0 .4.2.7.5.9s.3.3.3.4V44c0 .2-.2.4-.4.4H40c-.7-.6-1-1.5-1-2.4V26.2c-.1-.5-.6-.9-1.1-.9-.6.1-1.2.3-1.7.6v15.5c0 .4.1.5.6.9.3.2.3.3.3.5V44c0 .2-.2.4-.4.4h-7.3c-.3 0-.6-.2-.6-.4v-1.1c0-.1 0-.2.5-.7s.5-.6.5-.7v-17c0-.4-.2-.6-.6-.8-.1 0-.4-.1-.4-.3V22c0-.1.3-.2.5-.2H36c.2 0 .3.2.3.4v1.7c1.1-1 2.5-2.3 4.9-2.3s3.4 1.5 3.9 2.5c1.6-1.4 2.9-2.5 5.1-2.5 2.5 0 4.1 1.5 4.1 4v15.9c.1.1.1.2.5.6M20.4 22.3c0-1.4-.5-2.8-1.9-2.8h-.9v13.9h1.2c1 0 1.6-1.2 1.6-2.8v-8.3zm-1.2-4.6c5.1 0 8.3 3.4 8.4 8.8 0 7-4.4 8.8-7.9 8.8h-2.1v5.5c-.1.6.3 1.2.9 1.3.5.2.7.4.7 1.5 0 .5-.1.9-.6.9h-8.1c-.7 0-.7-1-.7-1.4s.1-.5.2-.7c.1-.1.3-.2.5-.3s.6-.3.6-.5V21.2c0-.6-.4-1-.9-1.2s-.5-.3-.5-1.5c0-.6 0-.9.7-.9l8.8.1"
      />
    </svg>
  </div>
</template>

<style scoped>
svg {
  width: 1.1em;
  height: 1.1em;
}

.background {
  fill: currentColor;
}

.text {
  fill: white;
}
</style>
